// Discussion Plugin Type Start
export const DISCUSSION_PLUGIN_TYPE_MENTION = "mention";
// Discussion Plugin Type End
